import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';

import { TruSenseLangHelper } from '@trusense/language';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const ProductCard = () => import(/* webpackChunkName: "ProductCard" */ '@/components/ProductCard.vue');

const changeLang = (lang: string): void => {
  TruSenseLangHelper.changeLocale(lang);
};

const truScoreProduct = ref([
  {
    name: '',
    icon: '',
    description: '',
    userUrl: 'https://docs.trusense.dev/truscore-user-guide.pdf',
    apiUrl: 'https://www.notion.so/masivapp/API-Documentation-6e7b574d098a401e91f7cae4256c79bb?pvs=4',
    docUrl: 'https://www.notion.so/masivapp/TruScore-f8abe5b44ded47b69ace3c8c9ed5f388?pvs=4',
  },
]);

const truAuthProduct = ref([
  {
    name: 'MNV',
    icon: 'aq-icon-mnv',
    description: 'documentation.mnv',
    userUrl: 'https://docs.trusense.dev/mnv-guide.pdf',
    apiUrl: 'https://www.notion.so/masivapp/Get-start-with-docs-fe5b1a4105ea4baab43ac4007f8c78b0?pvs=4',
    docUrl: 'https://www.notion.so/masivapp/MNV-fd8163c2414a41719ae24c166cb04688?pvs=4',
  },
]);

onMounted(() => changeLang('en'));

return { __sfc: true,ProductCard, changeLang, truScoreProduct, truAuthProduct }
}

})